import { render, staticRenderFns } from "./Intent.vue?vue&type=template&id=2d4514dc&scoped=true&"
import script from "./Intent.vue?vue&type=script&lang=js&"
export * from "./Intent.vue?vue&type=script&lang=js&"
import style0 from "./Intent.vue?vue&type=style&index=0&id=2d4514dc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4514dc",
  null
  
)

export default component.exports